import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-sm text-red-500"
}
const _hoisted_2 = { class: "flex flex-col gap-1 text-sm" }
const _hoisted_3 = { class: "flex flex-col gap-1 text-sm" }
const _hoisted_4 = { class: "flex flex-col gap-1 text-sm" }
const _hoisted_5 = { class: "flex flex-col gap-1 text-sm" }
const _hoisted_6 = { class: "flex flex-col gap-1 text-sm" }
const _hoisted_7 = { class: "flex gap-3" }
const _hoisted_8 = ["disabled"]

import type { DevRoeEntity } from '#shared/lex'
import type { Strict } from '#shared/cms/strict'

type EntityValue = Omit<Strict<DevRoeEntity.Record>, '$type'>


export default /*@__PURE__*/_defineComponent({
  __name: 'EntityForm',
  props: {
    initial: {},
    submitLabel: {}
  },
  emits: ["submit"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const form = reactive({
  name: props.initial?.name ?? '',
  bluesky: props.initial?.socialHandles?.bluesky ?? '',
  linkedin: props.initial?.socialHandles?.linkedin ?? '',
  mastodon: props.initial?.socialHandles?.mastodon ?? '',
  website: props.initial?.website ?? '',
})

const submitting = ref(false)
const error = ref<string | null>(null)

async function onSubmit () {
  error.value = null
  submitting.value = true
  try {
    const socialHandles = {
      ...(form.bluesky ? { bluesky: form.bluesky.replace(/^@/, '') } : {}),
      ...(form.linkedin ? { linkedin: form.linkedin } : {}),
      ...(form.mastodon ? { mastodon: form.mastodon.replace(/^@/, '') } : {}),
    }
    const value: EntityValue = {
      name: form.name,
      ...(Object.keys(socialHandles).length ? { socialHandles } : {}),
      ...(form.website ? { website: form.website } : {}),
      ...(props.initial?.createdAt ? { createdAt: props.initial.createdAt } : { createdAt: new Date().toISOString() }),
    }
    emit('submit', value)
  }
  catch (err) {
    error.value = err instanceof Error ? err.message : String(err)
  }
  finally {
    submitting.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_NuxtLink = _resolveComponent("NuxtLink")!

  return (_openBlock(), _createElementBlock("form", {
    class: "flex flex-col gap-4 max-w-lg",
    onSubmit: _withModifiers(onSubmit, ["prevent"])
  }, [
    (_unref(error))
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_unref(error)), 1))
      : _createCommentVNode("", true),
    _createElementVNode("label", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-muted" }, [
        _createTextVNode("Name "),
        _createElementVNode("span", { class: "text-red-500" }, "*")
      ], -1)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).name) = $event)),
        required: "",
        type: "text",
        class: "bg-accent px-3 py-2"
      }, null, 512), [
        [_vModelText, _unref(form).name]
      ])
    ]),
    _createElementVNode("label", _hoisted_3, [
      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-muted" }, "Bluesky handle", -1)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).bluesky) = $event)),
        type: "text",
        placeholder: "nuxt.bsky.social",
        class: "bg-accent px-3 py-2"
      }, null, 512), [
        [_vModelText, _unref(form).bluesky]
      ])
    ]),
    _createElementVNode("label", _hoisted_4, [
      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-muted" }, "LinkedIn handle", -1)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).linkedin) = $event)),
        type: "text",
        placeholder: "nuxtjs",
        class: "bg-accent px-3 py-2"
      }, null, 512), [
        [_vModelText, _unref(form).linkedin]
      ])
    ]),
    _createElementVNode("label", _hoisted_5, [
      _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-muted" }, "Mastodon handle", -1)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).mastodon) = $event)),
        type: "text",
        placeholder: "nuxt@fosstodon.org",
        class: "bg-accent px-3 py-2"
      }, null, 512), [
        [_vModelText, _unref(form).mastodon]
      ])
    ]),
    _createElementVNode("label", _hoisted_6, [
      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-muted" }, "Website", -1)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).website) = $event)),
        type: "url",
        class: "bg-accent px-3 py-2"
      }, null, 512), [
        [_vModelText, _unref(form).website]
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", {
        type: "submit",
        disabled: _unref(submitting),
        class: "bg-primary text-background px-4 py-2 hover:bg-primary/90 transition-colors disabled:opacity-60"
      }, _toDisplayString(_unref(submitting) ? 'Saving…' : (__props.submitLabel ?? 'Save')), 9, _hoisted_8),
      _createVNode(_component_NuxtLink, {
        to: "/admin/entities",
        class: "text-muted hover:text-primary self-center text-sm"
      }, {
        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
          _createTextVNode(" Cancel ", -1)
        ]))]),
        _: 1
      })
    ])
  ], 32))
}
}

})